import "../Styles/Pages.css";
import "../Styles/FindUs.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Map from "../Components/Map";
import Return from "../Components/Return";
import OrnamentalDivider from "../Components/OrnamentalDivider";
import BookNowCTA from "../Components/BookNowCTA";
import { BsGeoAltFill, BsEnvelopeFill } from "react-icons/bs";

const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=The+old+house+restaurant+Afandou&destination_place_id=ChIJTevhum1vlRQRFD7bB7VQvHE";

export default function FindUs() {
  return (
    <div className="page_content">
      <Header />

      <section className="find_us" aria-labelledby="findus-heading">
        <h1 id="findus-heading">Find Us</h1>
        <OrnamentalDivider />

        <p className="find_us__address">
          <strong>The Old House Restaurant</strong>
          Afantou village, Rhodes, Greece
        </p>

        <Map />

        <div className="find_us__contact">
          <a
            className="md-button md-button--filled md-state-layer"
            href={DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsGeoAltFill size={18} /> Get directions
          </a>
          <a
            className="md-button md-button--tonal md-state-layer"
            href="mailto:info@oldhouse.gr"
          >
            <BsEnvelopeFill size={16} /> info@oldhouse.gr
          </a>
        </div>

        <BookNowCTA variant="inline" />
      </section>

      <Return />
      <Footer />
    </div>
  );
}
